import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Info, X } from "lucide-react";

// Correction 4 — Live Beta Notice.
// Non-intrusive band that appears once per browser; dismissed via localStorage so
// users don't see it repeatedly. Does not block any workflow.
const STORAGE_KEY = "kandake_beta_notice_ack_v1";

export default function BetaNoticeBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const ack = window.localStorage.getItem(STORAGE_KEY);
      setVisible(!ack);
    } catch (_e) {
      // localStorage unavailable (e.g. private mode) — show once per page load
      setVisible(true);
    }
  }, []);

  function acknowledge() {
    try { window.localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch (_e) { /* noop */ }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="beta-notice-banner"
      className="border-b"
      style={{
        background: "hsl(40 48% 92%)",
        borderColor: "hsl(40 48% 78%)",
        color: "hsl(347 72% 22%)",
      }}
    >
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-start gap-3">
        <Info className="w-4 h-4 mt-0.5 shrink-0" aria-hidden="true" />
        <div className="text-[12px] leading-snug flex-1 min-w-0">
          <span className="font-medium uppercase tracking-[0.14em] text-[10px] mr-2">Live Beta</span>
          <span className="text-foreground/80">
            Kandake Compliance Service is currently operating in Live Beta. While all core functionality is available, occasional refinements and usability improvements may occur as we continue enhancing the platform experience.
          </span>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 px-2 text-[11px] uppercase tracking-[0.14em] shrink-0"
          onClick={acknowledge}
          data-testid="beta-notice-acknowledge"
          aria-label="Acknowledge beta notice"
        >
          Got it
          <X className="w-3 h-3 ml-1.5" />
        </Button>
      </div>
    </div>
  );
}
